import * as React from 'react';
/**
 *
 * Original name: space
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A542
 *
 */
export const SpaceSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M94.947 25.053C86.949 17.055 75.191 13 60 13h-3v45.182L15.776 79.689l1.009 2.519C23.277 98.427 38.221 107 60 107c15.191 0 26.949-4.055 34.947-12.053C102.945 86.949 107 75.192 107 60c0-15.192-4.055-26.95-12.053-34.947ZM60 101c-18.214 0-30.493-6.237-36.546-18.549L63 61.818v-42.76c25.218.995 38 14.756 38 40.942 0 27.206-13.794 41-41 41ZM19 60c0-24.019 10.759-37.577 32-40.425v-6.042c-10.9 1.33-19.609 5.182-25.947 11.52C17.055 33.05 13 44.808 13 60a68.923 68.923 0 0 0 1.287 13.7l5.561-2.9A65.264 65.264 0 0 1 19 60Z", fill: "currentColor" })));
